import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { surpriseConfig } from "./data";

export default function SurprisePage() {
  return <CityPageTemplate config={surpriseConfig} />;
}